<!--
    描述：平台账户 --- 平台提现
    时间：2021-01-06
    Created by ws
-->
<template>
    <div class="company-account-main">
        <!-- 主页面 -->
        <template v-if="!routeQuery">
            <div class="card-box" :class="{ 'is-collapse': !showCard.top }">
                <div class="card-title" @click="handleShow('top')">
                    {{ baseInfo.sname
                    }}<i class="header-arrow" :class="showCard.top ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </div>
                <div class="card-content flex" v-show="showCard.top">
                    <div class="left-cardNum">
                        <h4 class="title">平台资金概览</h4>
                        <div class="money-box">
                            <div class="money-left">
                                <p class="money-top"><span class="money-icon">¥</span><span class="money-title">{{
                                    allMoney }}</span>
                                </p>
                                <p>平台总收入</p>
                            </div>
                            <div class="money-center">
                                <p class="money-top"><span class="money-icon">¥</span> <span class="money-title">{{
                                    platMoney }}</span> </p>
                                <p>运营方收入（可提现金额）</p>
                            </div>
                            <div class="money-right">
                                <p class="money-top"><span class="money-icon">¥</span><span class="money-title">{{
                                    merMoney }}</span> </p>
                                <p>商户收入</p>
                            </div>

                        </div>
                        <div class="text-center">
                            <span class="btn-style" v-if="roleBtns.includes('ptzhtx')" @click="toWithDraw">提现</span>
                            <span class="btn-style" v-if="roleBtns.includes('ptzhcz')">充值</span>
                        </div>
                    </div>
                    <div class="right-card-table">
                        <h3 class="header overflow-hidden">
                            <span class="fl">账户收支</span>
                            <span class="fr cursor-pointer" style="color: #2971cc" @click="showMore">更多>></span>
                        </h3>
                        <p class="remark text-overflow">
                            {{ curDay }}
                            <span class="remark-text">收入：
                                <i class="remark-money-success">{{
                                    parseFloat(incomeTotal).toFixed(2)
                                }}</i></span>
                            <span class="remark-text">支出：
                                <i class="remark-money-error">{{
                                    parseFloat(expendTotal).toFixed(2)
                                }}</i></span>
                        </p>
                        <div class="table-box">
                            <el-table border :data="curDayList" ref="paymentTable" size="mini" height="100%">
                                <el-table-column prop="changeTime" label="时间" min-width="200" align="center"
                                    show-overflow-tooltip></el-table-column>
                                <el-table-column prop="chgAmount" label="账户变动" min-width="200" header-align="center"
                                    align="right" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <div>
                                            {{
                                                scope.row.chgAmount
                                                    ? (
                                                        parseFloat(
                                                            scope.row.chgAmount
                                                        ) / 100
                                                    ).toFixed(2)
                                                    : "0.00"
                                            }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="type" label="备注" min-width="120" align="center"
                                    show-overflow-tooltip></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 设置提现账户 -->
            <div class="card-box" :class="{ 'is-collapse': !showCard.center }">
                <div class="card-title" @click="handleShow('center')">
                    设置提现账户<i class="header-arrow" :class="showCard.center ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                        "></i>
                </div>
                <div class="card-content account-swiper-container" v-show="showCard.center">
                    <!-- <div
                        class="add-block"
                        v-if="!baseInfo.list"
                        @click="openDialog('add')"
                    >
                        <p class="block-icon"><i class="el-icon-plus"></i></p>
                        <p class="font-14">添加提现账户</p>
                    </div> -->
                    <div class="add-block exist-block" :class="getBankSvg(baseInfo.bank)">
                        <h3 class="block-title">
                            <!-- <span class="fl">{{ baseInfo.bank }}</span> -->
                            <span class="fr status-text" :class="{ 'exist-text': checkText === '审核中' }">{{ checkText
                            }}</span>
                        </h3>
                        <p class="block-text">{{ baseInfo.sname }}</p>
                        <p class="block-text">{{ baseInfo.account }}</p>
                    </div>
                    <div class="add-swiper">
                        <swiper ref="mySwiper" :options="swiperOptions" class="swiper-box">
                            <swiper-slide class="swiper-slide">1</swiper-slide>
                            <swiper-slide class="swiper-slide">2</swiper-slide>
                            <swiper-slide class="swiper-slide">3</swiper-slide>
                            <swiper-slide class="swiper-slide">4</swiper-slide>
                            <swiper-slide class="swiper-slide">5</swiper-slide>
                        </swiper>

                        <div class="swiper-button-prev"></div>
                        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
                        <div class="swiper-button-next"></div>
                        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
                    </div>
                </div>
            </div>

            <!-- 提现记录 -->
            <div class="card-box" :class="{ 'is-collapse': !showCard.bottom }" v-loading="showLoading">
                <div class="card-title" @click="handleShow('bottom')">
                    提现记录<i class="header-arrow" :class="showCard.bottom ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                        "></i>
                </div>
                <div class="card-content pdb0" v-if="showCard.bottom">
                    <records-table ref="recordsTable" :bizUserid="bizUserid" :showEdit="showEdit"></records-table>
                </div>
            </div>

            <!-- 新增 、 编辑弹窗 -->
            <el-dialog :visible.sync="infoDialog.visible" :title="infoDialog.title" :width="infoDialog.width"
                @closed="handleClosed" custom-class="full-dialog" :close-on-click-modal="false" center>
                <!-- 基本信息 -->
                <baseForm v-if="infoDialog.visible && infoDialog.type === 'add'" v-loading="infoDialog.btnLoading"
                    element-loading-text="耐心等待中..." ref="baseForm" :baseInfo="baseInfo" :mode="infoDialog.mode"
                    :memberId="memberId" :checkState="checkState" :bizUserid="bizUserid" @setAccountId="setAccountId"
                    @setFileList="setFileList" @setFileId="setFileId" @on-error="onError" :disabled="isDisabled">
                </baseForm>

                <!-- 手机号验证 -->
                <el-form :model="phoneForm" label-width="140px" :rules="phoneRule" class="phone-form" ref="phoneForm"
                    :show-message="false" center v-loading="infoDialog.btnLoading"
                    v-if="infoDialog.visible && infoDialog.type === 'tel'">
                    <el-row>
                        <el-col :span="16">
                            <el-form-item label="短信接收手机号：" prop="tiedPhone">
                                <el-input v-model="phoneForm.tiedPhone" class="mr10" maxlength="11"
                                    placeholder="请输入短信接收手机号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7" :offset="1">
                            <el-button type="primary" class="btn-blue w100" @click="getPhonecCode"
                                :loading="infoDialog.codeLoading" :disabled="infoDialog.codeDisabled">{{
                                    infoDialog.codeText }}</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="手机验证码：" prop="scode">
                                <el-input v-model="phoneForm.scode" placeholder="请输入手机验证码"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="16">
                            <p class="agreement" @click="openAgreement">
                                点击签署《通联支付网络交易资金管理服务三方协议》
                            </p>
                        </el-col>
                        <el-col :span="8" class="align-right">
                            <el-tag :type="agreementState === '已签署' ? 'success' : 'info'" size="small">{{ agreementState
                            }}</el-tag>
                        </el-col>
                    </el-row>
                </el-form>

                <div slot="footer" class="text-center">
                    <!-- 第一步 -->
                    <template v-if="infoDialog.type === 'add'">
                        <el-button size="small" class="btn" @click="infoDialog.visible = false">取消</el-button>
                        <el-button type="primary" size="small" class="btn btn-blue" v-show="checkText !== '可提现'"
                            @click="doNext" :loading="infoDialog.btnLoading">下一步</el-button>
                    </template>

                    <!-- 第二步 手机号验证 -->
                    <template v-if="infoDialog.type === 'tel'">
                        <el-button size="small" class="btn" :loading="infoDialog.btnLoading"
                            @click="infoDialog.visible = false">取消</el-button>
                        <el-button type="primary" size="small" class="btn btn-blue" @click="doSubmit"
                            :loading="infoDialog.btnLoading">提交</el-button>
                    </template>
                </div>
            </el-dialog>

            <el-dialog :visible.sync="visibleState" title="审核中" width="80%" center :close-on-click-modal="false">
                <!-- waiting 状态 -->
                <div v-if="visibleState" class="waiting-box">
                    正在审核中，请耐心等候, {{ timerNum }}s...
                </div>
            </el-dialog>

            <!-- 查看模板 -->
            <el-dialog :visible.sync="visibleUrl" title="通联支付网络交易资金管理服务三方协议" :close-on-click-modal="false" width="80%"
                class="addPay" fullscreen @closed="closeAgressMent" center>
                <div class="h100">
                    <iframe :src="openUrl" frameborder="0" height="100%" width="100%"></iframe>
                </div>
            </el-dialog>

            <!-- 提现弹窗 -->
            <el-dialog :visible.sync="visibleWithDraw" title="提示" width="600px" center :close-on-click-modal="false">
                <!-- waiting 状态 -->
                <div v-if="visibleWithDraw" class="waiting-box">
                    <el-row class="draw-row">
                        <el-col :span="6" :offset="1" class="right-text">到账对公账户：</el-col>
                        <el-col :span="16">
                            <svg-icon :icon-class="getBankSvg(baseInfo.bank)" class="fl bank-icon"></svg-icon>
                            <!-- <span class="fr status-text">{{
                                isCheck ? "可提现 （24小时内到账）" : "审核中"
                            }}</span> -->
                            <span class="fr status-text">{{
                                "可提现 （24小时内到账）"
                            }}</span>
                        </el-col>
                    </el-row>
                    <el-row class="draw-row">
                        <el-col :span="6" :offset="1" class="right-text">提现金额：</el-col>
                        <el-col :span="16">
                            <el-input v-input-filter:price v-model="withDrawMoney" @blur="withDrawBlur">
                                <template slot="append">元</template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row class="error-row" v-show="showError">
                        <el-col :offset="7" :span="17" class="color-red">提示：提现金额超出账户余额</el-col>
                    </el-row>
                    <el-row class="info-row">
                        <el-col :offset="7" :span="17">当前账户余额 {{ platMoney }} 元，<span class="color-blue"
                                @click="setAllMoney">全部提现</span></el-col>
                    </el-row>
                    <el-row class="info-row">
                        <el-col :offset="7" :span="17">服务费：1.00元/笔, 提现金额不能少于50.00 元</el-col>
                    </el-row>
                    <el-row class="draw-row">
                        <el-col :offset="7" :span="17">
                            <el-button size="small" class="btn-blue" @click="submitWithDraw">提现</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
        </template>

        <!-- 明细页面 -->
        <template v-else>
            <account-details></account-details>
        </template>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
// import style (<= Swiper 5.x)
import "swiper/css/swiper.css";
import { dateFormat } from "utils/tools.js";
import inputFilter from "utils/input-filter/index.js";
import { getBalance, getAccountDetail, doWithDraw } from "api/modules/account";
import {
    sendVerificationCode,
    selectDeptByUserId,
    accountVerify,
    signContract,
    getApplyRecordResult,
    saveApplyRecord,
    bindPhone,
    platformMemberInfoEcho
} from "api/modules/paymentSettlement";

import recordsTable from "./account-records-table";
import accountDetails from "./account-details";
import baseForm from "./baseForm.vue";
import { mapState } from "vuex";
export default {
    components: {
        Swiper,
        SwiperSlide,
        recordsTable,
        accountDetails,
        baseForm,
    },
    directives: {
        swiper: directive,
        inputFilter,
    },
    data() {
        return {
            curDay: dateFormat("yyyy-mm-dd"),
            showCard: {
                top: true,
                center: true,
                bottom: true,
            },
            showLoading: false,
            swiperOptions: {
                loop: true,
                slidesPerView: 2,
                loopedSlides: 2,
                // allowTouchMove: false, // 禁止滑动
                // effect: "coverflow", // 切换效果
                // fadeEffect: {
                //     crossFade: true,
                // },
                // pagination: {
                // 	el: '.swiper-pagination',
                // 	clickable: true,
                // },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                // Some Swiper option/callback...
            },
            // 页面变量

            curDayList: [], // 当天收支明细
            incomeTotal: 0, // 当天收入合计
            expendTotal: 0, // 当天支出合计
            // 提现账户 所有变量
            hasInfo: false,
            isDisabled: false,
            checkState: 0, // 审核状态
            infoDialog: {
                visible: false,
                title: "添加收款账户",
                type: "add",
                mode: "add",
                width: "1000px",
                btnLoading: false,
                checkState: false,
                codeDisabled: false, // 验证码按钮
                codeLoading: false,
                codeText: "点击获取验证码", // 验证码按钮显示文字
            },
            baseInfo: {
                sname: "",
                creditCode: "",
                legalar: "",
                idCard: "",
                legalPhone: "",
            },
            visibleImg: false,
            visibleUrl: false,
            visibleState: false,
            visibleWithDraw: false,
            sumNum: 0,
            openUrl: "", // 通联协议地址
            bizUserid: "",
            memberId: "", // 会员ID
            accountId: "", // 账户ID （数据库）
            fileList: {},
            fileId: '',
            // 手机号弹窗
            timeChange: null,
            phoneForm: {
                tiedPhone: "",
                scode: "",
            },
            phoneRule: {
                tiedPhone: [
                    {
                        required: true,
                        message: "手机号不能为空",
                        trigger: "blur",
                    },
                    {
                        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                        message: "手机号码格式有误！",
                        trigger: "blur",
                    },
                ],
                scode: [
                    {
                        required: true,
                        message: "验证码不能为空",
                        trigger: "blur",
                    },
                ],
            },
            agreementState: "未签署",
            isEdit: true,
            showEdit: true,
            timer: null,
            timerNum: 35,
            numInterval: null,
            agreeTimer: null,
            // 提现金额
            withDrawMoney: 0,
            showError: false,
            allMoney: '', // 平台总收入
            platMoney: '', // 运营方收入（可提现金额）
            merMoney: '', // 商户收入
        };
    },
    created() {
        // 查询全部信息
        this.selectDeptByUserId();
    },
    methods: {
        // 切换展示 card
        handleShow(type) {
            this.showCard[type] = !this.showCard[type];
        },

        // 切换展示 slide
        changeSlide(direction) {
            if (direction === "prev") {
                console.log(this.$refs.mySwiper);
                // this.$refs.mySwiper.slidePrev()
            } else {
                // this.$refs.mySwiper.slideNext()
            }
        },

        // 展示更多
        showMore() {
            // if (this.bizUserid === "" || !this.isCheck) {
            //     this.$message.warning("请先完善账户信息后再查看！");
            //     return;
            // }
            this.$router.push({
                path: "/about-account-withdraw",
                query: {
                    type: "detail",
                    bizUserid: this.bizUserid,
                },
            });
        },

        // 查询余额
        getBalanceMoney() {
            getBalance({
                bizUserId: this.bizUserid,
                memberId: '1348841516314923011',
                type: 1, // typel-----类型 1.平台 2.企业  注：能公社交易项目传2
            })
                .then((res) => {
                    // 平台总收入
                    this.allMoney = res.data.allMoney || "0.00"

                    // 运营方收入（可提现金额）
                    this.platMoney = res.data.platMoney || "0.00"

                    // 商户收入
                    this.merMoney = res.data.merMoney || "0.00"
                })
                .catch((err) => {
                    // console.log(err)
                });
        },

        // 查询明细接口
        getDefaultDetail() {
            let params = {
                bizUserId: this.bizUserid, //-----商户系统中唯一编号
                dateStart: this.curDay, // -----开始时间（开始时间和结束时间相差不能超过一个月，后台也会提示）
                dateEnd: this.curDay, // -----结束时间
                current: "1",
                size: "1000", // -----页面大小（如果取前五条，把"size":"5"，结束时间传当前时间）
            };
            getAccountDetail(params).then((res) => {
                if (res.operationCode === 1) {
                    this.curDayList = res.data.records;

                    // 计算 收支
                    if (res.data.records.length > 0) {
                        this.amountTotal(res.data.records);
                    }
                }
            });
        },

        // 计算收支总额
        amountTotal(list) {
            this.incomeTotal = 0;
            this.expendTotal = 0;

            // 收入数组求和
            let _increase = list.filter((x) => parseFloat(x.chgAmount) > 0);
            _increase = _increase.map((x) => {
                return x.chgAmount;
            });
            this.incomeTotal = (parseFloat(_increase.sum()) / 100).toFixed(2);

            // 支出数组求和
            let _decrease = list.filter((x) => parseFloat(x.chgAmount) < 0);
            _decrease = _decrease.map((x) => {
                return x.chgAmount;
            });
            this.expendTotal = (
                parseFloat(
                    _decrease
                        .map((x) => {
                            return Math.abs(x);
                        })
                        .sum()
                ) / 100
            ).toFixed(2);
        },

        // 点击提现按钮
        toWithDraw() {
            // 运营展示的都是有账户的
            this.visibleWithDraw = true;
            return
            // 已有账户
            if (this.baseInfo.list && this.baseInfo.list.length > 0) {
                // 区分审核状态
                let _failed = this.baseInfo.list.find((x) => x.state === 2);
                if (this.isCheck) {
                    // 审核通过 --- 提现
                    this.visibleWithDraw = true;
                } else if (_failed) {
                    // 审核失败
                    this.$confirm("提现账户审核失败，请修改提现账户资料。", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.openDialog("edit");
                        })
                        .catch(() => { });
                } else {
                    // 审核中
                    this.$confirm("提现账户审核中，请稍后再提现。", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.selectDeptByUserId();
                        })
                        .catch(() => { });
                }
            } else {
                // 未创建账户
                this.$confirm("您尚未设置提现账户，是否立即前往设置?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.openDialog("add");
                    })
                    .catch(() => { });
            }
        },

        // 提现金额失去焦点事件
        withDrawBlur() {
            // 限制最低输入 50
            if (parseFloat(this.withDrawMoney) < 2) {
                this.withDrawMoney = 2;
            }
            this.showError = false;
            if (parseFloat(this.withDrawMoney) > this.platMoney) {
                this.showError = true;
            }
        },

        // 提现弹窗 点击全部金额
        setAllMoney() {
            this.withDrawMoney = parseFloat(this.platMoney);
            // //创建input标签,将input的值设置为需要复制的内容
            // let input = document.createElement("input");
            // input.value = this.platMoney;
            // //添加并选中input标签，执行复制
            // document.body.appendChild(input);
            // input.select();
            // document.execCommand("copy");
            // this.$message.success("复制成功!");
            // //移除input标签
            // document.body.removeChild(input);
        },

        // 确认提现
        submitWithDraw() {
            if (this.withDrawMoney == '') {
                this.$message.error("提现金额不能为空!");
                return;
            }
            if (this.withDrawMoney > this.platMoney) {
                this.$message.error("账户余额不足!");
                return;
            }

            let params = {
                bizUserId: this.bizUserid, //-----商户系统中唯一编号
                bankCardNo: this.baseInfo.account, // 企业对公账户或者个人银行卡账户
                bankName: "中国银行", // 开户银行
                amount: this.withDrawMoney, // -----提现金额（单位 元）
                createUser: this.userInfo.sname, //提款人
                type: 0,
                sysNo: "1002", // -----系统识别号 1001 表示能公社交易项目 1002表示能公社运营平台
            };
            doWithDraw(params)
                .then((res) => {
                    if (res.operationCode === 1) {
                        this.$message.success("提现成功，24小时内可到账!");
                        this.visibleWithDraw = false;
                        // 提现金额 置0
                        this.withDrawMoney = 0
                        // 重新查询
                        this.getAllInfo();
                        // 提现记录表刷新
                        this.$refs.recordsTable.doSearch()
                    }
                })
                .catch((err) => { });
        },

        // 页面加载全部
        getAllInfo() {
            // 余额
            this.getBalanceMoney();
            // 收支明细
            this.getDefaultDetail();
        },

        // 提现接口------------------位置 -------------------
        // 再次分割线
        // 获取银行 svg name
        getBankSvg(bankName) {
            let className = "";
            switch (bankName) {
                case "1002046001": // 中国工商银行
                    className = "gongshangyinhang";
                    break;
                case "1002046002": // 中国农业银行
                    className = "zhongguonongyeyinhang";
                    break;
                case "1002046003": // 中国银行
                    className = "zhongguoyinhang";
                    break;
                case "1002046004": // 中国建设银行
                    className = "jiansheyinhang";
                    break;
                case "1002046005": // 交通银行
                    className = "jiaotongyinhang";
                    break;
                case "1002046006": // 浦发银行
                    className = "pufayinhang";
                    break;
                case "1002046007": // 中信银行
                    className = "zhongxinyinhang";
                    break;
                case "1002046008": // 招商银行
                    className = "zhaoshangyinhang";
                    break;
                case "1002046009": // 中国光大银行
                    className = "guangdayinhang";
                    break;
                case "1002046010": // 华夏银行
                    className = "huaxiayinhang";
                    break;
                case "1002046011": // 民生银行
                    className = "minshengyinhang";
                    break;
                case "1002046012": // 兴业银行
                    className = "xingyeyinhang";
                    break;
                case "1002046013": // 广发银行
                    className = "guangfayinhang";
                    break;
                case "1002046014": // 上海银行
                    className = "shanghaiyinhang";
                    break;
                case "1002046015": // 浙商银行
                    className = "zheshangyinhang";
                    break;
                case "1002046016": // 北京银行
                    className = "beijingyinhang";
                    break;
                case "1002046017": // 平安银行
                    className = "pinganyinhang";
                    break;
                case "1002046018": // 杭州银行
                    className = "hangzhouyinhang";
                    break;
                case "1002046019": // 宁波银行
                    className = "ningboyinhang";
                    break;
                case "1002046020": // 南京银行
                    className = "nanjingyinhang";
                    break;
                case "1002046021": // 中国邮政储蓄银行
                    className = "zhongguoyouzhengchuxuyinhang";
                    break;
                case "1002046022": // 徽商银行
                    className = "huishangyinhang";
                    break;
                default:
                    className = "";
            }
            return className;
        },

        // 获取企业信息
        selectDeptByUserId() {
            selectDeptByUserId({}).then((d) => {
                if (d.operationCode == 1) {
                    // 设置会员 或者 回显
                    let params = {
                        id: d.data.id, // 企业ID
                        type: 1, // 1 能公社运营  2 能工社
                        memberType: 1, // 1 平台会员  2企业会员 3 个人会员
                        sname: d.data.sname,
                        cardNo: d.data.creditCode,
                    };
                    this.echoAccount(params);

                    this.baseInfo = d.data;
                }
            });
        },

        // 设置会员 或者 回显
        echoAccount(params) {
            platformMemberInfoEcho(params).then((res) => {
                // console.log(res)
                this.bizUserid = res.data.bizUserid;
                this.memberId = res.data.id;

                // if (res.data.list && res.data.list.length > 0) {
                this.baseInfo = res.data;

                this.getAllInfo();
                setTimeout(() => {
                    // 提现记录表刷新
                    this.$refs.recordsTable.doSearch()
                }, 100)
                return
                this.accountId = res.data.id;

                let state = res.data.list.find((x) => x.type === 0).state;
                this.checkState = state;

                let agree = res.data.list.find((x) => x.type === 3);
                if (agree && agree.state === 1) {
                    this.isEdit = false;
                }

                // 查询状态
                // this.getAllRecords();
                // }
            });
        },

        // 添加收款账号
        openDialog(type) {
            this.infoDialog.mode = type;
            this.isDisabled = type !== "add";
            this.infoDialog.title = type === "add" ? "添加收款账户" : "编辑收款账户";
            this.infoDialog.visible = true;
            this.infoDialog.width = "1000px";
        },

        // 设置账户ID
        setAccountId(id) {
            this.accountId = id;
        },

        // 设置文件对象
        setFileList(obj) {
            this.fileList = obj;
        },

        // 设置文件上传主键ID
        setFileId(id) {
            this.fileId = id
        },

        // 查询所有业务状态
        getAllRecords() {
            if (this.accountId === "") {
                return;
            }

            let that = this;
            let fun1 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 0,
                    })
                        .then((res) => {
                            that.checkState = res.data.state || 0;
                        })
                        .catch((err) => { });
                });
            };
            let fun2 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 1,
                    })
                        .then((res) => { })
                        .catch((err) => { });
                });
            };
            let fun3 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 2,
                    })
                        .then((res) => { })
                        .catch((err) => { });
                });
            };
            let fun4 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 3,
                    })
                        .then((res) => { })
                        .catch((err) => { });
                });
            };

            if (this.baseInfo.list && this.baseInfo.list.length > 0) {
                let a = this.baseInfo.list.find((x) => x.type === 0);
                a && a.state !== 1 ? fun1() : "";

                let b = this.baseInfo.list.find((x) => x.type === 1);
                b && b.state !== 1 ? fun2() : "";

                let c = this.baseInfo.list.find((x) => x.type === 2);
                c && c.state !== 1 ? fun3() : "";

                let d = this.baseInfo.list.find((x) => x.type === 3);
                d && d.state !== 1 ? fun4() : "";

                // 是否显示修改按钮(全部审核通过)
                if (
                    a &&
                    a.state === 1 &&
                    b &&
                    b.state === 1 &&
                    c &&
                    c.state === 1 &&
                    d &&
                    d.state === 1
                ) {
                    // 调取接口
                    this.getAllInfo();
                    this.showEdit = false;
                }
            }
        },

        // 点击下一步
        doNext() {
            this.infoDialog.btnLoading = true;
            let that = this;
            if (this.infoDialog.mode === "add") {
                this.doSave(false);
            } else {
                // 编辑状况下
                switch (this.checkState) {
                    case 0: // --- 待审核 --- 主动调接口
                        this.$message.warning("暂未审核通过，请耐心等待审核结果！");
                        break;
                    case 1: // --- 审核通过 --- 进入下一步
                        setTimeout(() => {
                            this.infoDialog.btnLoading = false;
                        }, 1000);
                        this.visibleState = false;

                        let params = {
                            file1: this.$refs.baseForm.$refs.codeUpload.addList[0],
                            file2: this.$refs.baseForm.$refs.idCardZ.addList[0],
                            file3: this.$refs.baseForm.$refs.idCardF.addList[0],
                        };

                        let status = this.$refs.baseForm.doSubmit(false, true);
                        if (!status) {
                            return;
                        } else {
                            this.$refs.baseForm.uploadPictures(params, this.fileId);

                            // 如果已经签约了 手机号
                            if (this.baseInfo.tiedPhone !== '') {
                                this.handleClosed()
                                return
                            }
                            // 查协议状态
                            this.getAgreeState();

                            this.infoDialog.visible = true;
                            this.infoDialog.type = "tel";
                            this.infoDialog.width = "630px";
                            this.infoDialog.title = "手机号验证";
                        }
                        // that.$message.success("基本信息保存成功！");

                        break;
                    case 2: // --- 审核失败 --- 重新保存
                        this.doSave(true);
                }
            }
        },

        // doSave
        doSave(isEdit) {
            let that = this;

            // 保存
            let status = that.$refs.baseForm.doSubmit(isEdit);
            if (!status) {
                setTimeout(() => {
                    that.infoDialog.btnLoading = false;
                    that.numInterval ? clearInterval(that.numInterval) : "";
                }, 1000);
                return;
            } else {
                that.timerNum = 35;
                // that.visibleState = true;

                // 倒计时
                that.numInterval = setInterval(() => {
                    that.timerNum--;

                    if (that.timerNum === 0) {
                        that.handleClosed();
                        clearInterval(that.numInterval);
                    }
                }, 1000);
                that.getIntervalRecords();
            }
        },

        // 新增频繁调用
        getIntervalRecords() {
            let that = this;
            this.timer = setInterval(() => {
                // 如果倒计时已结束， 回到首页
                if (that.timerNum === 0) {
                    clearInterval(that.timer);
                    that.handleClosed();
                    that.$message.warning("网络波动，请稍候查询审核结果！");
                }

                if (that.accountId !== "") {
                    // 获取审核状态
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 0,
                    })
                        .then((res) => {
                            that.checkState = res.data.state || 0;
                            if (res.data.state === 1) {
                                // 审核成功 --- 清除定时器
                                clearInterval(that.timer);
                                clearInterval(that.numInterval);
                                that.timer = null;
                                that.visibleState = false;
                                that.infoDialog.btnLoading = false;

                                that.$refs.baseForm.uploadPictures(that.fileList, that.fileId);
                                that.$message.success("基本信息保存成功！");
                                // 查协议状态
                                this.getAgreeState();

                                that.infoDialog.visible = true;
                                that.infoDialog.type = "tel";
                                that.infoDialog.width = "630px";
                                that.infoDialog.title = "手机号验证";
                            } else if (res.data.state === 2) {
                                // 审核失败 --- 接口报错，重新编辑
                                clearInterval(that.timer);
                                clearInterval(that.numInterval);
                                that.timer = null;
                                that.visibleState = false;
                                that.infoDialog.btnLoading = false;
                                that.$message.warning(
                                    "审核失败，请重新编辑确认后保存数据!"
                                );
                            } else {
                                // 未审核好 -- 继续请求
                            }
                        })
                        .catch((err) => { });
                }
            }, 1000);
        },

        // 点击获取验证码
        getPhonecCode() {
            this.infoDialog.codeDisabled = true;
            this.infoDialog.codeLoading = true;

            if (this.phoneForm.tiedPhone === "") {
                this.$message.warning("请填写手机号!");

                setTimeout(() => {
                    this.infoDialog.codeDisabled = false;
                    this.infoDialog.codeLoading = false;
                }, 1500);
                return;
            }

            sendVerificationCode({
                tiedPhone: this.phoneForm.tiedPhone,
                bizUserId: this.bizUserid,
            }).then((res) => {
                this.infoDialog.codeLoading = false;
                if (res.operationCode == 1) {
                    this.$message.success("验证码获取成功, 请尽快使用!");
                    let that = this;
                    let downCount = 60;

                    this.timeChange = setInterval(() => {
                        downCount -= 1;
                        that.infoDialog.codeText = `${downCount}s 后再次获取`;

                        if (downCount == 0) {
                            clearInterval(that.timeChange);
                            that.infoDialog.codeText = "点击获取授权码";
                            that.infoDialog.codeDisabled = false;
                        }
                    }, 1000);
                }
            });
        },

        // 新增、编辑弹窗关闭事件
        handleClosed() {
            this.visibleState = false;
            this.infoDialog.visible = false;
            this.infoDialog.type = "add";
            this.infoDialog.mode = "add";
            this.infoDialog.width = "80%";

            // 刷新页面
            this.selectDeptByUserId();

            if (this.numInterval) {
                clearInterval(this.numInterval);
            }

            if (this.timer) {
                clearInterval(this.timer);
            }

            if (this.agreeTimer) {
                clearInterval(this.agreeTimer);
            }

            // 查询状态
            // this.getAllRecords();
        },

        // 新增接口报错处理
        onError(type) {
            if (type === 1) {
                // 设置企业信息 -- 通联接口报错
                if (this.numInterval) {
                    clearInterval(this.numInterval);
                }

                if (this.timer) {
                    clearInterval(this.timer);
                }

                this.visibleState = false;
                this.infoDialog.btnLoading = false;
                // this.$message.warning("审核失败，请重新编辑确认后保存数据!");
            }
        },

        // 打开协议弹窗
        openAgreement() {
            signContract({
                bizUserId: this.bizUserid,
            }).then((res) => {
                if (res.code === 0) {
                    this.openUrl = res.data;
                    this.visibleUrl = true;
                }
            });
        },

        // 查询协议状态
        getAgreeState(isFirst) {
            let that = this;
            // 往数据库塞记录
            getApplyRecordResult({
                accountId: this.accountId,
                type: 3,
            })
                .then((res) => {
                    // 如果没有记录 则塞一条
                    if (res.operationCode === 2) {
                        saveApplyRecord({
                            accountId: this.accountId,
                            type: 3,
                        })
                            .then((res) => { })
                            .catch((err) => { });
                    } else {
                        if (res.data.state === 1) {
                            that.agreementState = "已签署";
                        } else {
                            that.agreementState = "未签署";
                        }
                    }
                })
                .catch((err) => { });
        },

        // 协议弹窗关闭事件
        closeAgressMent() {
            let that = this;
            that.agreeTimer = setInterval(() => {
                if (that.agreementState === "已签署") {
                    clearInterval(that.agreeTimer);
                }

                getApplyRecordResult({
                    accountId: that.accountId,
                    type: 3,
                })
                    .then((res) => {
                        if (res.data.state === 1) {
                            that.agreementState = "已签署";
                        } else {
                            that.agreementState = "未签署";
                        }
                    })
                    .catch((err) => {
                        clearInterval(that.agreeTimer);
                    });
            }, 1000);
        },

        // 最终提交
        doSubmit() {
            this.infoDialog.btnLoading = true;
            let _scode = this.phoneForm.scode.replace(/\s/g, "");
            // 绑定手机号
            this.$refs.phoneForm.validate((valid) => {
                if (valid) {
                    if (_scode === "") {
                        this.$message.warning("验证码不能为空！");
                        setTimeout(() => {
                            this.infoDialog.btnLoading = false;
                        }, 1000);
                        return;
                    }

                    if (this.agreementState !== "已签署") {
                        this.$message.warning("请先打开弹窗签署协议！");
                        setTimeout(() => {
                            this.infoDialog.btnLoading = false;
                        }, 1000);
                        return;
                    }

                    // 最终确认
                    bindPhone({
                        bizUserId: this.bizUserid,
                        tiedPhone: this.phoneForm.tiedPhone,
                        verificationCode: this.phoneForm.scode,
                    })
                        .then((res) => {
                            this.infoDialog.btnLoading = false;
                            if (res.code === 0) {
                                setTimeout(() => {
                                    this.$message.success("提交成功！");
                                    this.handleClosed();
                                }, 1000);
                            }
                        })
                        .catch((err) => {
                            this.infoDialog.btnLoading = false;
                        });
                } else {
                    this.$message("请完善手机号和验证码！");
                    setTimeout(() => {
                        this.infoDialog.btnLoading = false;
                    }, 1000);
                }
            });
        },

        // 点击取消
        doCancel() {
            this.infoDialog.visible = false;
        },
    },
    computed: {
        // 当前默认企业
        ...mapState("app", {
            curCompany: (state) => state.curCompany,
        }),
        ...mapState('menu', {
            roleBtns: (state) => state.roleBtns,
        }),
        ...mapState("user", {
            userInfo: (state) => state.userInfo
        }),
        // 路由参数对象
        routeQuery() {
            let obj =
                Object.keys(this.$route.query).length > 0 ? this.$route.query : null;
            return obj;
        },
        // 是否审核通过了
        isCheck() {
            if (!this.baseInfo.list) {
                return false;
            }
            let status = this.checkState;
            let pic1 = this.baseInfo.list.find((x) => x.type === 1);
            let pic2 = this.baseInfo.list.find((x) => x.type === 2);
            let agree = this.baseInfo.list.find((x) => x.type === 3);
            if (
                status === 1 &&
                pic1 &&
                pic1.state === 1 &&
                pic2 &&
                pic2.state === 1 &&
                agree.state === 1
            ) {
                return true;
            } else {
                return false;
            }
        },

        // 审核失败、审核中文字区分
        checkText() {
            if (!this.baseInfo.list) {
                return "";
            }
            // 审核通过
            if (this.isCheck) {
                return "可提现";
            }

            let obj = this.baseInfo.list.find((x) => x.state === 2);
            if (obj) {
                return "审核不通过";
            } else {
                return "审核中";
            }
        },
    },
};
</script>

<style scoped lang="less">
.company-account-main {
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
    // display: flex;
    // flex-direction: column;

    .border-box {
        border: 1px solid #ccc;
    }

    .pdb0 {
        padding-bottom: 0 !important;
    }

    .card-box {
        // height: 100%;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px 5px 0px 0px;
        border: 1px solid #ebeef5;
        background-color: #fff;
        color: #303133;
        transition: 0.3s;
        margin-bottom: 10px;

        &.is-collapse {
            height: 40px;
        }
    }

    .card-title {
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        border-bottom: 1px solid #ebeef5;
        background-color: #dcdfe6;

        .header-arrow {
            float: right;
            font-size: 20px;
            line-height: 40px;
            cursor: pointer;
            padding-left: 15px;
        }
    }

    .card-content {
        height: calc(~"100% - 40px");
        padding: 30px;
    }

    .left-cardNum {
        width: 460px;
        height: 220px;
        padding: 20px 30px;
        background: url("../../../assets/images/new-account.png") no-repeat;
        box-shadow: 0px 0px 20px 0px rgba(38, 113, 204, 0.3);
        border-radius: 20px;

        .title {
            width: 100%;
            font-size: 20px;
            line-height: 24px;
            color: #fff;
            // text-align: center;
        }

        .money-box {
            display: flex;
            justify-content: space-between;
            color: #fff;
            padding: 14px 0 28px 0;
            font-size: 14px;
            align-items: baseline;
            line-height: 25px;
            text-align: center;

            .money-center {
                .money-title {
                    font-size: 30px;
                }
            }

            .money-title {
                font-weight: 600;
            }


            .money-icon {
                display: inline-block;
                font-size: 12px !important;
                padding-right: 4px;
            }

            .money-top {

                font-size: 16px !important;
            }
        }

        .btn-style {
            display: inline-block;
            width: 128px;
            height: 38px;
            line-height: 38px;
            border-radius: 3px;
            font-size: 14px;
            vertical-align: middle;
            margin: 0 10px;
            cursor: pointer;
        }

        .btn-style:first-child {
            color: #fff;
            border: 1px solid #fff;
        }

        .btn-style:last-child {
            color: #2671cc;
            background: linear-gradient(0deg, #d6e3d7 0%, #eef1ee 100%);
        }
    }

    .right-card-table {
        margin-left: 50px;
        width: calc(~"100% - 410px");
        height: 220px;

        .header {
            color: #202020;
            font-size: 16px;
            height: 24px;
            line-height: 24px;
        }

        .remark {
            font-size: 12px;
            line-height: 24px;
        }

        .remark-text {
            color: #066666;
            font-size: 12px;
            margin-left: 20px;
        }

        .remark-money-success {
            color: #72aa2c;
            font-size: 14px;
            font-style: normal;
        }

        .remark-money-error {
            color: #e60012;
            font-size: 14px;
            font-style: normal;
        }

        .table-box {
            height: calc(~"100% - 54px");
        }
    }

    .account-swiper-container {
        display: flex;
        // height: 200px;

        .add-block {
            width: 360px;
            height: 180px;
            background: #f6f6f6;
            border-radius: 10px;
            text-align: center;
            color: #666;
            cursor: pointer;
            padding: 0 20px;
        }

        .exist-block {
            cursor: unset;
            background: linear-gradient(0deg, #d5dfe3 0%, #eff6fc 100%);
            position: relative;
        }

        .exist-text {
            position: absolute;
            width: 100px;
            height: 88px;
            top: 24px;
            right: 11px;
            background: url("../../../assets/bank_images/shenhezhong.png") no-repeat center center;
        }

        .zhongguoyinhang {
            background: url("../../../assets/bank_images/zhongguoyinhang.png") no-repeat center center;
        }

        .gongshangyinhang {
            background: url("../../../assets/bank_images/gongshangyinhang.png") no-repeat center center;
        }

        .zhongguonongyeyinhang {
            background: url("../../../assets/bank_images/zhongguonongyeyinhang.png") no-repeat center center;
        }

        .jiansheyinhang {
            background: url("../../../assets/bank_images/jiansheyinhang.png") no-repeat center center;
        }

        .zhongxinyinhang {
            background: url("../../../assets/bank_images/zhongxinyinhang.png") no-repeat center center;
        }

        .zhongguoyouzhengchuxuyinhang {
            background: url("../../../assets/bank_images/zhongguoyouzhengchuxuyinhang.png") no-repeat center center;
        }

        .zhaoshangyinhang {
            background: url("../../../assets/bank_images/zhaoshangyinhang.png") no-repeat center center;
        }

        .pufayinhang {
            background: url("../../../assets/bank_images/pufayinhang.png") no-repeat center center;
        }

        .xingyeyinhang {
            background: url("../../../assets/bank_images/xingyeyinhang.png") no-repeat center center;
        }

        .shanghaiyinhang {
            background: url("../../../assets/bank_images/shanghaiyinhang.png") no-repeat center center;
        }

        .zheshangyinhang {
            background: url("../../../assets/bank_images/zheshangyinhang.png") no-repeat center center;
        }

        .pinganyinhang {
            background: url("../../../assets/bank_images/pinganyinhang.png") no-repeat center center;
        }

        .ningboyinhang {
            background: url("../../../assets/bank_images/ningboyinhang.png") no-repeat center center;
        }

        .nanjingyinhang {
            background: url("../../../assets/bank_images/nanjingyinhang.png") no-repeat center center;
        }

        .minshengyinhang {
            background: url("../../../assets/bank_images/minshengyinhang.png") no-repeat center center;
        }

        .jiaotongyinhang {
            background: url("../../../assets/bank_images/jiaotongyinhang.png") no-repeat center center;
        }

        .huaxiayinhang {
            background: url("../../../assets/bank_images/huaxiayinhang.png") no-repeat center center;
        }

        .guangfayinhang {
            background: url("../../../assets/bank_images/guangfayinhang.png") no-repeat center center;
        }

        .guangdayinhang {
            background: url("../../../assets/bank_images/guangdayinhang.png") no-repeat center center;
        }

        .hangzhouyinhang {
            background: url("../../../assets/bank_images/hangzhouyinhang.png") no-repeat center center;
        }

        .beijingyinhang {
            background: url("../../../assets/bank_images/beijingyinhang.png") no-repeat center center;
        }

        .huishangyinhang {
            background: url("../../../assets/bank_images/huishangyinhang.png") no-repeat center center;
        }

        .block-text {
            font-size: 14px;
            color: #202020;
            font-weight: 400;
            line-height: 30px;
            text-align: left;
        }

        .status-text {
            font-size: 14px;
            font-weight: normal;
        }

        .block-title {
            height: 60px;
            line-height: 60px;
            margin-bottom: 20px;
            overflow: hidden;
        }

        .bank-icon {
            height: 30px;
            width: 140px;
            margin-top: 15px;
        }

        .block-icon {
            height: 44px;
            font-size: 30px;
            margin-top: 50px;
        }

        .add-swiper {
            margin-left: 20px;
            width: calc(~"100% - 360px");
            height: 100%;
            position: relative;
            padding: 0 20px;
            display: none;
        }

        .swiper-box {
            height: 100%;
        }

        .swiper-slide {
            width: 200px;
            height: 98%;
            border: 1px solid #ccc;
            // margin-left: 20px;
            margin-right: 20px;
        }

        .swiper-slide:last-child {
            // margin-right: 0;
        }
    }

    // 弹窗样式
    .addPay {
        /deep/ .el-dialog__body {
            height: calc(~"100% - 45px");
            max-height: unset;
        }
    }

    .agreement {
        font-size: 13px;
        color: #5489d0;
        line-height: 24px;
        border-bottom: 1px solid #5489d0;
        text-align: center;
        cursor: pointer;
    }

    .align-right {
        text-align: right;
    }

    .phone-form {
        padding: 20px 30px;
    }
}

.draw-row {
    height: 40px;
    line-height: 40px;
    margin-bottom: 5px;

    .bank-icon {
        height: 30px;
        width: 100px;
        margin-top: 5px;
    }

    .right-text {
        text-align: right;
        padding-right: 25px;
    }
}

.info-row {
    height: 30px;
    line-height: 30px;

    .color-blue {
        color: #2671cc;
    }
}

.error-row {
    height: 22px;
    line-height: 22px;

    .color-red {
        color: #ff2f2f;
    }
}
</style>
